import { useAppDispatch, useAppSelector } from '@/store';
import { setTheme, type ThemeMode } from '@/store/uiSlice';
import { useAuthContext } from '@/features/auth/AuthProvider';
import MfaSection from '@/features/settings/MfaSection';
import BillingSection from '@/features/settings/BillingSection';

const THEMES: ThemeMode[] = ['light', 'dark', 'system'];

export default function SettingsPage(): JSX.Element {
  const { user } = useAuthContext();
  const dispatch = useAppDispatch();
  const theme = useAppSelector((s) => s.ui.theme);

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <h1 className="text-2xl font-bold">Settings</h1>

      <div className="card">
        <h3 className="font-semibold">Profile</h3>
        <div className="mt-3 grid grid-cols-2 gap-4 text-sm">
          <div>
            <span className="text-slate-500">Name</span>
            <p className="font-medium">{user?.firstName} {user?.lastName}</p>
          </div>
          <div>
            <span className="text-slate-500">Email</span>
            <p className="font-medium">{user?.email} {user?.emailVerified ? '✓' : '(unverified)'}</p>
          </div>
          <div>
            <span className="text-slate-500">Role</span>
            <p className="font-medium">{user?.role}</p>
          </div>
        </div>
      </div>

      <div className="card">
        <h3 className="font-semibold">Appearance</h3>
        <div className="mt-3 flex gap-2">
          {THEMES.map((t) => (
            <button
              key={t}
              onClick={() => dispatch(setTheme(t))}
              className={`rounded-lg px-4 py-2 text-sm capitalize ${theme === t ? 'bg-brand-600 text-white' : 'bg-slate-100 dark:bg-slate-800'}`}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      <MfaSection />
      <BillingSection />
    </div>
  );
}
